export const API_URL = process.env.API_URL;
export const CDN_URL = process.env.CDN_URL;
